import { gql } from "@apollo/client";

const ELIMINAR_USUARIO_RESPONSABLE = gql`
    mutation eliminarUsuarioDeArea($idArea: Int!, $idUsuario: Int!){
        eliminarUsuarioDeArea(idArea: $idArea, idUsuario: $idUsuario) {
            id
        }
    }
`;

export default ELIMINAR_USUARIO_RESPONSABLE;